import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const seekingAlphaHeaders = {
  "x-rapidapi-key": "bfc901e967msh82cf4299c413314p1def60jsn44b6f851aaa0",
  "x-rapidapi-host": "seeking-alpha.p.rapidapi.com",
};

const baseUrl = "https://seeking-alpha.p.rapidapi.com";

const createRequest = (url) => ({ url, headers: seekingAlphaHeaders });

export const cryptoNewsApi = createApi({
  reducerPath: "cryptoNewsApi",
  baseQuery: fetchBaseQuery({ baseUrl }),
  endpoints: (builder) => ({
    getMetrics: builder.query({
      query: ({ symbols, fields }) =>
        createRequest(
          `/symbols/get-metrics?symbols=${symbols}&fields=${fields}`
        ),
    }),
  }),
});

export const { useGetMetricsQuery } = cryptoNewsApi;
